module.exports = __webpack_public_path__ + "step4_child_to_parent_daughter.b963cf7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4_child_to_parent_daughter.jpg
// module id = l0Kd
// module chunks = 0